<script>
import { Carousel, Slide } from "vue3-carousel";
import Provider_Expertise from "@/assets/json/provider-expertise.json";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      Provider_Expertise: Provider_Expertise,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
        loop: true,
        margin: 24,
      },

      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 991px and up
        991: {
          itemsToShow: 4,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 6,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
  },
};
</script>
<template>
  <div class="accordion-item mb-3">
    <div class="accordion-header" id="accordion-headingTwo">
      <div
        class="accordion-button p-0"
        data-bs-toggle="collapse"
        data-bs-target="#accordion-collapseTwo"
        aria-expanded="true"
        aria-controls="accordion-collapseTwo"
        role="button"
      >
        Area Of Expertise
      </div>
    </div>
    <div
      id="accordion-collapseTwo"
      class="accordion-collapse collapse show"
      aria-labelledby="accordion-headingTwo"
    >
      <div class="accordion-body p-0 mt-3 pb-1">
        <P
          >From small residential repairs to large-scale commercial and industrial
          projects, is your go-to provider for all electrical needs. Contact us today to
          schedule a consultation or to learn more about how we can assist with your next
          project.
        </P>
        <div>
          <div class="row g-3">
            <div class="col-xl-12">
              <div class="area-expert-slider owl-carousel mb-3">
                <Carousel
                  :wrap-around="true"
                  :settings="settings"
                  :breakpoints="breakpoints"
                >
                  <Slide v-for="item in Provider_Expertise" :key="item.id">
                    <div class="text-center area-expert">
                      <span class="d-block mb-2"
                        ><img
                          :src="require(`@/assets/img/icons/${item.Image}`)"
                          class="w-auto m-auto"
                          alt="Img"
                      /></span>
                      <p class="fw-medium fs-14">{{ item.Name }}</p>
                    </div>
                  </Slide>
                  <template #addons> </template>
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
